import * as angular from "angular";
import { IInputType } from "@interfaces/IInputType";
import { InputStateDescription } from "@interfaces/IVehicleInput";



export class InputTypeService {

    static $inject = ["$http", "$q"];

    constructor(
        private readonly $http: angular.IHttpService,
        private readonly $q: angular.IQService
    ){}

    getInputTypes(invalidateCache = false): angular.IPromise<IInputType[]> {
        return this
            .$http({
                url: `/api/inputTypes`,
                method: "GET",
                params: { minsToLive: 60, invalidateCache: invalidateCache }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IInputType[]>) => {
                return response.data.sort((a, b) => a.Name < b.Name ? -1 : a.Name > b.Name ? 1 : 0);
            });
    }


    addOrUpdateInputTypes(inputType: IInputType): angular.IPromise<any> {
        return this
            .$http({
                url: `/api/inputTypes`,
                method: "POST",
                data: inputType
            })
    }

    deleteInputTypes(inputType: IInputType): angular.IPromise<any> {
        return this
            .$http({
                url: `/api/inputTypes/delete`,
                method: "POST",
                data: inputType
            })
    }

    getStateDescriptions(): angular.IPromise<any> {
        return this.$q((resolve) =>
            resolve([
                InputStateDescription.OnOff,
                InputStateDescription.OpenClosed,
                InputStateDescription.ActiveInactive,
                InputStateDescription.ConnectedDisconnected,
            ])
        );
    }
}
